/* eslint-disable no-unused-vars */
enum PartnerType {
    AffiliatePartner = 1, // İş Ortağı
    AdvertisingChannel = 2, // Reklam Kanalı
    API = 3,
    Influencer = 4,
    Personnel = 5,
}
export default PartnerType;
